import request from "@/config/utils/request";

// 编辑
export function editDemoUser(data) {
  return request({
    url: "/apis/demo/user/editDemoUser",
    method: "POST",
    data
  });
}
// 添加
export function saveDemoUser(data) {
  return request({
    url: "/apis/demo/user/saveDemoUser",
    method: "POST",
    data
  });
}
// 删除
export function removeDemoUser(data) {
  return request({
    url: "/apis/demo/user/removeDemoUser",
    method: "post",
    data
  });
}
// 详情
export function getUserDemoById(data) {
  return request({
    url: "/apis/demo/user/getUserDemoById",
    method: "POST",
    data
  });
}
// 列表查询
export function getListbycheck(data) {
  return request({
    url: "/apis/demo/plusProject/selectPulsProjectList",
    method: "POST",
    data
  });
}
// 新增列表
export function savePulsProject(data) {
  return request({
    url: "/apis/demo/plusProject/savePulsProject",
    method: "POST",
    data
  });
}
// 甘特图列表删除
export function removePulsProject(data) {
  return request({
    url: "/apis/demo/plusProject/removePulsProject",
    method: "POST",
    data
  });
}
// 甘特图查询
export function loadProject(data) {
  return request({
    url: "/apis/demo/plusProject/loadProject",
    method: "POST",
    data
  });
}
// 甘特图保存
export function savePlusProjectTask(data) {
  return request({
    url: "/apis/demo/plusProject/savePlusProjectTask",
    method: "POST",
    data
  });
}
